import React, { PureComponent } from 'react';
import { Table, Icon, Button, message } from 'antd';
import Modal from '../../../components/Modal/index';
import services from '../../../services/api';

class MenuList extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {}
  edit(record) {
    this.props.edit(record);
  }
  delete(record) {
    Modal.open({
      title: '提示',
      width: '300px',
      content: '确定要删除?',
      isOkBtn: true,
      isCancelBtn: true,
      ok: () => {
        services.menuConfig.delete({ id: record.value }).then(data => {
          if (data.code === 0) {
            message.success(data.msg);
            Modal.close();
            this.props.queryList();
          } else {
            message.error(data.msg);
          }
        });
      },
      cancel: () => {
        Modal.close();
      }
    });
  }
  render() {
    const columns = [
      {
        title: '菜单名',
        dataIndex: 'title',
        key: 'title'
      },
      {
        title: '路由地址',
        dataIndex: 'url',
        key: 'url',
        width: '30%'
      },
      {
        title: '图标',
        dataIndex: 'icon',
        key: 'icon',
        width: '12%'
      },
      {
        title: '操作',
        key: 'action',
        width: '12%',
        render: (text, record, index) => {
          return (
            <div className="table-action">
              <Button
                type="primary"
                size="small"
                onClick={this.edit.bind(this, record)}
              >
                <Icon type="edit" />
              </Button>
              <Button
                type="primary"
                size="small"
                disabled={record.children && record.children.length > 0}
                onClick={this.delete.bind(this, record)}
              >
                <Icon type="delete" />
              </Button>
            </div>
          );
        }
      }
    ];

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        console.log(
          `selectedRowKeys: ${selectedRowKeys}`,
          'selectedRows: ',
          selectedRows
        );
      },
      onSelect: (record, selected, selectedRows) => {
        console.log(record, selected, selectedRows);
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        console.log(selected, selectedRows, changeRows);
      }
    };
    return (
      <div>
        {this.props.data ? (
          <Table
            columns={columns}
            rowSelection={rowSelection}
            dataSource={this.props.data}
            defaultExpandAllRows={true}
          />
        ) : (
          '暂无数据'
        )}
      </div>
    );
  }
}

export default MenuList;
